import { DocumentSnapshot } from "@atgof-firebase/types";
import { useImage } from "../data/image";
import { Pressable, View } from "react-native";
import ErrorBoundary from "./ErrorBoundary";
import { Image } from "expo-image";
import { Editable } from "./Editable";
import { Icon, Text } from "react-native-paper";
import { HOUR_MILLIS } from "@atgof-common/util";

export function Thumbnail({
  doc,
  referencePath,
  index,
  showPhoto,
  size,
  readonly,
  basic,
}: {
  doc: DocumentSnapshot;
  referencePath: string | undefined;
  index: number;
  showPhoto?: (index: number) => void;
  size: number;
  readonly?: boolean;
  basic?: boolean;
}) {
  const { image, registerAsCached, registerCompletion, registerFailure } =
    useImage(doc, referencePath, true);
  if (!image) return null;
  const { ref, source, notes, blurhash, thumbnailSource } = image;
  const { width, height } = source;
  const aspect = width && height ? width / height : 1;
  const containerStyle = {
    width: aspect * size,
    height: size,
  };
  const imageComponent = (
    <ErrorBoundary>
      {typeof image.inProgress === "object" ? (
        <View
          style={{
            ...containerStyle,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon
            source={
              new Date().getTime() -
                (image.inProgress.uploadStartedMillis ?? 0) <
              HOUR_MILLIS
                ? "progress-upload"
                : "progress-alert"
            }
            size={size / 3}
          />
        </View>
      ) : (
        <Image
          source={{ ...source, ...thumbnailSource }}
          cachePolicy="disk"
          placeholder={{ blurhash }}
          style={containerStyle}
          onLoad={(evt) => {
            registerAsCached(evt.cacheType === "disk");
            registerCompletion();
          }}
          onError={(evt) => {
            registerFailure(evt.error);
          }}
        />
      )}
    </ErrorBoundary>
  );
  return (
    <View style={{ gap: 4 }}>
      <View
        style={
          basic
            ? {}
            : {
                alignItems: "center",
                backgroundColor: "#888888",
                padding: 10,
              }
        }
      >
        {showPhoto ? (
          <Pressable onPress={() => showPhoto(index)}>
            {imageComponent}
          </Pressable>
        ) : (
          imageComponent
        )}
      </View>
      {basic ? null : readonly ? (
        notes?.length ? (
          <Text variant="bodySmall">{notes}</Text>
        ) : null
      ) : (
        <Editable
          text={notes ?? ""}
          onChange={(v) => ref.update({ notes: v })}
        />
      )}
    </View>
  );
}
